import { render, staticRenderFns } from "./AnswerVideo.vue?vue&type=template&id=74ba006b&scoped=true"
import script from "./AnswerVideo.vue?vue&type=script&lang=js"
export * from "./AnswerVideo.vue?vue&type=script&lang=js"
import style0 from "./AnswerVideo.vue?vue&type=style&index=0&id=74ba006b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba006b",
  null
  
)

export default component.exports